<div class="container-fluid col-12 col-md-10">

    <button appPreventDoubleClick class="floating-button" mat-fab color="primary" (throttledClick)="save(false);" [disabled]="!canSave()">
        <mat-icon>save</mat-icon>
    </button>
    <div class="container-fluid mt-4 p-2">
        <div class="border rounded-1 background-light p-3">
            <!-- <h5 class="card-header">Localisation</h5> -->
            <div class="row">
                <h2 class="col text-center fw-bold"> Localisation</h2>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>X (L93)</mat-label>
                        <input matInput placeholder="X (L93)" type="number" [(ngModel)]="model.Position.L93X" [formControl]="IsX2FarControl">
                        <mat-error *ngIf="IsX2FarControl.hasError('pattern')">
                            Format erroné. 6 chiffres uniquement !
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Y (L93)</mat-label>
                        <input matInput placeholder="Y (L93)" type="number" [(ngModel)]="model.Position.L93Y" [formControl]="IsY2FarControl">
                        <mat-error *ngIf="IsY2FarControl.hasError('pattern')">
                            Format erroné. 7 chiffres uniquement !
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>
    <div class="container-fluid mt-4 p-2">
        <div class="border rounded-1 background-light p-3">
            <!-- <h5 class="card-header">Description</h5> -->
            <div class="row">
                <h2 class="col text-center fw-bold"> Description</h2>
            </div>
            <div class="row g-2">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Support</mat-label>
                        <mat-select placeholder="Support" [(ngModel)]="model.Support" (selectionChange)="selectedSupportType($event)" required>
                            <mat-option *ngFor="let s of SupportList;let i = index" [value]="s.idx">
                                <span>{{s.s}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Outil de prélèvement</mat-label>
                        <mat-select placeholder="Outil de prélèvement" [(ngModel)]="model.Outil" required>
                            <mat-option *ngFor="let o of OutilPrelevementList; let i = index" [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Code cadre racloir</mat-label>
                        <input matInput placeholder="Code cadre racloir" [(ngModel)]="model.CodeOutil" [disabled]="model.Outil !== 3">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Classe de vitesse</mat-label>
                        <mat-select placeholder="Classe de vitesse" [(ngModel)]="model.ClasseVitesse" required>
                            <mat-option *ngFor="let c of ClasseVitesseList;let i = index" [value]="getVitesseIndex(c)">
                                <span>{{c}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Largeur mouillée moyenne</mat-label>
                        <input matInput placeholder="Largeur mouillée moyenne" type="number" [(ngModel)]="model.LmMoy">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Ombrage</mat-label>
                        <mat-select placeholder="Ombrage" [(ngModel)]="model.Ombrage" required>
                            <mat-option *ngFor="let o of OmbreList;let i = index" [value]="i">
                                <span>{{o}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>Intensité du colmatage</mat-label>
                        <mat-select placeholder="Intensité du colmatage" [(ngModel)]="model.IntensiteColmatage" required>
                            <mat-option *ngFor="let ic of IntensiteColmatageList;let i = index" [value]="i">
                                <span>{{ic}}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>
    <div class="container-fluid mt-4 p-2">
        <div class="border rounded-1 background-light p-3">
            <!-- <h5 class="card-header">Occupation</h5> -->
            <div class="row">
                <h2 class="col text-center fw-bold"> Occupation</h2>
            </div>
            <div class="row">
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>% Total</mat-label>
                        <input matInput placeholder="% Total" type="number" [(ngModel)]="model.RecouvrementVegetal.PourcentTotal" [formControl]="TotalPercentageControl"
                               (keyup)="onTotalKeyUpEvent($event)">
                        <mat-error *ngIf="TotalPercentageControl.hasError('max')">
                            Merci de rester entre 0 et 100
                        </mat-error>
                        <mat-error *ngIf="!TotalPercentageControl.valid && !TotalPercentageControl.hasError('max')">
                            Respectez: Total > Bryo ou Algues
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>% Bryophytes</mat-label>
                        <input matInput placeholder="% Bryophytes" type="number" [(ngModel)]="model.RecouvrementVegetal.PourcentBryophytes" [formControl]="BryoPercentageControl"
                               (keyup)="onBryoKeyUpEvent($event)">
                        <mat-error *ngIf="!BryoPercentageControl.valid">
                            Respectez: Total > Bryo ou Algues
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col">
                    <mat-form-field class="w-100">
                        <mat-label>% Algues</mat-label>
                        <input matInput placeholder="% Algues" type="number" [(ngModel)]="model.RecouvrementVegetal.PourcentAlgues" [formControl]="AlguePercentageControl"
                               (keyup)="onAlgueKeyUpEvent($event)">
                        <mat-error *ngIf="!AlguePercentageControl.valid">
                            Respectez: Total > Bryo ou Algues
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        </div>
    </div>
    <div class="container-fluid mt-4 p-2">
        <div class="border rounded-1 background-light p-3">

            <div class="row g-0">

                <!-- <h5 class="d-flex align-items-center p-0 m-0 col-auto">Mesures station</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> Mesures station</h2>
                </div>
                <button appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openIBDMesureBox()">
                    <mat-icon>add</mat-icon>
                </button>
                <!-- <button appPreventDoubleClick throttleTime="200" mat-icon-button color="primary" (throttledClick)="removeLargeur()">
                        <mat-icon>remove</mat-icon>
                    </button> -->

            </div>

            <div class="row mt-3 ">
                <div *ngFor="let largueur of model.Prelevements; let i = index" class="col-12 col-sm-6 col-md-4 col-xl-3 py-1">
                    <div class="col">
                        <div class="row border rounded-pill p-3 pl-5 pt-3">
                            <div class="row g-0">
                                <mat-form-field class="col-9">
                                    <mat-label>Distance berge (m)</mat-label>
                                    <input matInput placeholder="Distance berge (m)" type="number" [(ngModel)]="largueur.DistanceBerge" disabled="true">
                                </mat-form-field>
                                <button class="col-2 ml-1" appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="openIBDMesureBox(largueur)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <mat-form-field class="col-9">
                                    <mat-label>Profondeur (cm)</mat-label>
                                    <input matInput placeholder="Profondeur (cm)" type="number" [(ngModel)]="largueur.Profondeur" disabled="true">
                                </mat-form-field>
                                <!-- <div class="col-2 ml-1 d-flex align-items-center"> -->
                                <button class="col-2 ml-1" appPreventDoubleClick [throttleTime]="200" mat-icon-button color="primary" (throttledClick)="removeMeasure(largueur)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <!-- </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>